import { render, staticRenderFns } from "./orden_de_compra_imprimir.vue?vue&type=template&id=3251cf84&lang=pug&"
import script from "./orden_de_compra_imprimir.vue?vue&type=script&lang=js&"
export * from "./orden_de_compra_imprimir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports